import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiDialogTitle = {
  styleOverrides: {
    root: {
      padding: '20px 24px',
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
  },
} satisfies Components<Theme>['MuiDialogTitle'];
